import React, { Component } from "react"
import { connect } from "react-redux"
import { Redirect } from "react-router-dom"

import SpinnerImage from "../common/SpinnerImage"
import { UncontrolledAlert } from "reactstrap"
import { randomInt } from "../../config/util-functions"

import LoginForm from "./LoginForm"
import ResetForm from "./ResetForm"
import ResetSuccessForm from "./ResetSuccessForm"

import {
    loginRequest,
    forgotRequest,
    toggleAuthForm
} from "../../actions/authentication-actions"

const totalBackgroundImages = 8

class Login extends Component {
    state = {
        loginPageBackground: randomInt(1, totalBackgroundImages + 1)
    }

    render() {
        const {
            authenticated,
            isLoading,
            error,
            requestLogin,
            requestForgotten,
            toggleForm,
            formName,
            redirectPath
        } = this.props
        const { loginPageBackground } = this.state
        let form

        switch (formName) {
            case "resetForm":
                form = (
                    <ResetForm
                        requestForgotten={requestForgotten}
                        toggleForm={toggleForm}
                    />
                )
                break
            case "resetSuccess":
                form = <ResetSuccessForm toggleForm={toggleForm} />
                break
            default:
                form = (
                    <LoginForm
                        requestLogin={requestLogin}
                        toggleForm={toggleForm}
                    />
                )
        }
        return (
            <div
                className={`vertical-fill login-background-${loginPageBackground}`}
                id="login-page"
            >
                {authenticated && <Redirect to={{ pathname: redirectPath }} />}
                <div className="container vertical-center login-layer">
                    <div className="clearfix login-section">
                        <header>
                            <h1 className="login-title">
                                Contextual Intelligence from the World Economic
                                Forum
                            </h1>
                        </header>
                        <main>
                            <div className="login-wrap">
                                {form}
                                {isLoading && <SpinnerImage isCentral />}
                                {error && (
                                    <UncontrolledAlert
                                        color={error.type || "danger"}
                                    >
                                        <div>
                                            <strong>{error.header}</strong>
                                        </div>
                                        {error.message}
                                    </UncontrolledAlert>
                                )}
                            </div>
                        </main>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = ({ authentication, presentation, navbar }) => {
    const { authenticated } = authentication
    const { isLoading, error, formName } = presentation.authentication

    return {
        authenticated,
        isLoading,
        error,
        formName
    }
}

const mapDispatchToProps = dispatch => ({
    requestLogin: (username, password) =>
        dispatch(loginRequest(username, password)),
    requestForgotten: email => dispatch(forgotRequest(email)),
    toggleForm: formName => () => dispatch(toggleAuthForm(formName))
})

export default connect(mapStateToProps, mapDispatchToProps)(Login)
